import React from 'react';
import {
  Box,
  Flex,
  SimpleGrid,
  Skeleton,
  SkeletonText,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';

import AnalyticsPage from '../../layout/IntegraAppPage';

const AdminEmpresaSkeleton: React.FC = () => {
  const pageWrapperBg = useColorModeValue('#EEF5F9', 'gray.900');
  const bgPage = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <AnalyticsPage>
      <Box bg={pageWrapperBg} minH="100vh" p={3}>
        <Flex justify="space-between" align="center" p={3}>
          <Box>
            <Skeleton height="26px" width="280px" mb={2} />
            <Skeleton height="14px" width="360px" />
          </Box>

          <Skeleton height="40px" width="120px" borderRadius="md" />
        </Flex>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={6}>
          {[1, 2, 3].map(item => (
            <Box key={item} bg={bgPage} borderRadius="xl" p={6} boxShadow="sm">
              <Flex justify="space-between" align="flex-start">
                <Box>
                  <Skeleton height="28px" width="80px" mb={3} />
                  <Skeleton height="16px" width="150px" />
                </Box>

                <Skeleton boxSize="24px" borderRadius="md" />
              </Flex>
            </Box>
          ))}
        </SimpleGrid>

        <Flex
          bg={bgPage}
          p={4}
          roundedTop="2xl"
          borderWidth="1px"
          borderBottomWidth={0}
          borderColor={borderColor}
        >
          <Skeleton height="40px" width="400px" borderRadius="md" />
        </Flex>

        <Box
          bg={bgPage}
          roundedBottom="2xl"
          p="4"
          pt="0"
          borderWidth="1px"
          borderColor={borderColor}
        >
          <Stack spacing={4} pt={4}>
            {[1, 2, 3, 4, 5].map(item => (
              <Box key={item}>
                <SkeletonText noOfLines={2} spacing="3" />
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>
    </AnalyticsPage>
  );
};

export default AdminEmpresaSkeleton;
